import { useMemo } from "react"
import { memo } from "react"
import { Svg, G, Path, Defs, ClipPath, Rect } from "react-native-svg"
import { Colors } from "src/constants/Colors"

type Props = {
  color?: string
  filled?: boolean
}

export const NotificationIcon = memo<Props>(({ filled, color }) => {
  const defaultColor = useMemo(() => color ?? Colors.white, [color])
  const fill = useMemo(() => (filled ? defaultColor : "none"), [filled, defaultColor])
  const stroke = useMemo(() => (filled ? "none" : defaultColor), [filled, defaultColor])

  return (
    <Svg width="25" height="24" viewBox="0 0 25 24">
      <Defs>
        <ClipPath id="clip0_notification">
          <Rect width="24" height="24" fill="white" transform="translate(0.75)" />
        </ClipPath>
      </Defs>
      <G clipPath="url(#clip0_notification)">
        <Path
          d="M21.2051 4.50098C21.2363 4.50432 21.2658 4.51576 21.293 4.53125L21.3047 4.53906C21.3353 4.56012 21.3607 4.58816 21.3779 4.62109C21.3952 4.65415 21.4036 4.69124 21.4033 4.72852V19.3232C21.4033 19.3833 21.3794 19.4419 21.3369 19.4844C21.3012 19.5199 21.2545 19.5406 21.2051 19.5469L21.0508 19.5186L10.3105 15.2236L10.2207 15.1875H8.94531V20.1465C8.94498 20.2064 8.9213 20.2642 8.87891 20.3066C8.83631 20.3491 8.77794 20.373 8.71777 20.373H4.79199L4.74805 20.3682C4.70445 20.3594 4.66378 20.3385 4.63184 20.3066C4.59994 20.2747 4.57815 20.234 4.56934 20.1904L4.56543 20.1455V15.1865H3.72656C3.66649 15.1865 3.60889 15.1626 3.56641 15.1201C3.52393 15.0776 3.50002 15.02 3.5 14.96V9.09473L3.50488 9.05078C3.51362 9.00715 3.53453 8.96654 3.56641 8.93457C3.59833 8.90265 3.639 8.88087 3.68262 8.87207L3.72754 8.86816H10.2207L10.3105 8.83203L21.0957 4.5166C21.1302 4.50274 21.1681 4.49705 21.2051 4.50098ZM12.2666 8.53516L10.8125 9.11621L10.498 9.24219V14.8154L10.8125 14.9414L12.2666 15.5225L12.9521 15.7959V8.26074L12.2666 8.53516Z"
          fill={fill}
          stroke={stroke}
        />
      </G>
    </Svg>
  )
})
